/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Loading/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Loading({
  children,
  viewPath = "/DesignSystem/PreviewDocument/Content/Content/HtmlFile/Loading"
  
}) {
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
  return (<React.Fragment
>
<div
  data-testid="Loading.Vertical"
  data-view-path={viewPath}
 style={{'--bc-1-2mx3jB': dtColorsNeutral400}}
 className={`views-block ${styles.Vertical}`}
/>
{children}
</React.Fragment>)
}